"use client";

import { c as _c } from "react/compiler-runtime";
import CardImage from "@/app/components/CardImage";

/**
 * Wraps any inline element and pops the full game-rendered card image on hover
 * (the same look as the tooltip widget). Reusable for card lists that render as
 * text/rows — leaderboards, run pages, etc. Falls back to the portrait art if a
 * card has no full render (mad_science).
 */
export default function CardHover(t0) {
  const $ = _c(7);
  const {
    cardId,
    fallbackArt: t1,
    className: t2,
    children
  } = t0;
  const fallbackArt = t1 === undefined ? null : t1;
  const className = t2 === undefined ? "" : t2;
  const t3 = `relative group/cardhover ${className}`;
  let t4;
  if ($[0] !== cardId || $[1] !== fallbackArt) {
    t4 = <span className="pointer-events-none absolute left-1/2 -translate-x-1/2 bottom-full mb-2 w-40 opacity-0 group-hover/cardhover:opacity-100 transition-opacity z-50"><CardImage id={cardId} art={fallbackArt} className="w-40 h-auto drop-shadow-[0_8px_24px_rgba(0,0,0,0.7)]" /></span>;
    $[0] = cardId;
    $[1] = fallbackArt;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== children || $[4] !== t3 || $[5] !== t4) {
    t5 = <span className={t3}>{children}{t4}</span>;
    $[3] = children;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}